'use client';

import { useEffect, useState } from 'react';

/**
 * Returns a copy of `value` that only updates after it has stopped changing for `delayMs`.
 * Useful for debouncing rapidly-changing input (e.g. a search box) before firing effects.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return debounced;
}
